import { IBAN_VALIDATOR_REGEX } from "../constants/validator.constants";
import { PolicyFieldsVM } from "../models/policy-field-vm.model";
import { FIELD_MODIFICATION_TYPE } from "../constants/field-modification-type.constants";

export function getIsVisible(policyFieldsVM: PolicyFieldsVM, key: string, name: string): boolean {
  const fields = policyFieldsVM?.fields[key];
  if (!fields) {
    return false;
  }
  const field = fields.find(y => y.name === name);
  return field ? field.isVisibleClientArea : false;
}

export function getIsEditable(
  policyFieldsVM: PolicyFieldsVM,
  key: string,
  name: string,
  hasEndorsementWait4Sign: boolean
): boolean {
  const fields = policyFieldsVM?.fields[key];
  if (!fields) {
    return false;
  }
  const field = fields.find(x => x.name === name);
  if (field?.clientAreaModificationType !== FIELD_MODIFICATION_TYPE.MANAGEMENT_ACT && hasEndorsementWait4Sign) {
    return false;
  }
  return field ? field.isEditableClientArea : false;
}


export function getIsOptionEditable(
  policyFieldsVM: PolicyFieldsVM,
  key: string,
  name: string,
  hasEndorsementWait4Sign: boolean,
  preventOptionSubscription: boolean,
  isOptionSelected: boolean
): boolean {
  
  if(preventOptionSubscription && isOptionSelected)
    return true;
  
  return getIsEditable(policyFieldsVM, key, name, hasEndorsementWait4Sign);
}


export function getInputClass(hasChanged: boolean, isEditable: boolean): string {
  if (hasChanged) {
    return "changed-inputtext";
  }
  return isEditable ? "normal-inputtext" : "disabled-inputtext";
}

export function getNonEditableInputClass(hasChanged: boolean): string {
  if (hasChanged) {
    return "disabled-inputtext-changed";
  }
  return "disabled-inputtext";
}

export function getDropdownClass(hasChanged: boolean, isEditable: boolean): string {
  if (hasChanged) {
    return "changed-dropdown";
  }
  return isEditable ? "normal-dropdown" : "disabled-dropdown";
}

export function getInputMaskClass(hasChanged: boolean, isEditable: boolean, isValid = true): string {
  if (!isValid) {
    return "invalid-inputmask";
  }
  if (hasChanged) {
    return "valid-inputmask";
  }
  return isEditable ? "normal-inputmask" : "disabled-inputmask";
}

export function getCalendarClass(hasChanged: boolean, isEditable: boolean, isValid = true): string {
  if (!isValid) {
    return "invalid-calendar";
  }
  if (hasChanged) {
    return "changed-calendar";
  }
  return isEditable ? "normal-calendar" : "disabled-calendar";
}

export function IbanValidator(iban: string): boolean {
  if (!iban) {
    return false;
  }

  const cleanedIban = iban.replace(/\s+/g, "").toUpperCase();

  if (!IBAN_VALIDATOR_REGEX.test(cleanedIban)) {
    return false;
  }

  if (!isValidChecksum(cleanedIban)) {
    return false;
  }

  return true;
}

function isValidChecksum(iban: string): boolean {
  const rearranged = iban.slice(4) + iban.slice(0, 4);
  const numericIban = rearranged
    .split("")
    .map(char => {
      const code = char.charCodeAt(0);
      if (char >= "A" && char <= "Z") {
        return (code - 55).toString();
      }
      return char;
    })
    .join("");

  let remainder = "";
  for (const element of numericIban) {
    remainder = (remainder + element).slice(-9);
    const num = parseInt(remainder, 10);
    remainder = (num % 97).toString();
  }

  return parseInt(remainder, 10) === 1;
}
